import { useEffect } from 'react';
import { useProfileImportStore } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/stores';
import { useContentGenerationStore } from './store';
import { ContentGenerationRecord } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Generate/types';

interface UseProfileAssignmentOptions {
  productData: ContentGenerationRecord[];
  handleProfileAssignment: (updates: Array<{
    retailerSku: string;
    contentGenId: string;
    profileId: string;
    profileName: string;
    profileVersion?: number;
  }>) => void;
}

/**
 * Hook to handle profile assignment and integration with Profile Import Store
 */
export const useProfileAssignment = ({
  productData,
  handleProfileAssignment
}: UseProfileAssignmentOptions) => {
  const { openSelectProfileModal, importedProfile, setImportedProfile } = useProfileImportStore();
  const { selectedItems } = useContentGenerationStore.getState();

  useEffect(() => {
    if (importedProfile) {
      const selectedProductItems = productData.filter(item => 
        selectedItems.has(item.retailerSku)
      );
      
      // Batch update all selected items with the new profile
      const updates = selectedProductItems.map(item => ({
        retailerSku: item.retailerSku,
        contentGenId: item.skuContentGenerationId || '',
        profileId: importedProfile.profileId,
        profileName: importedProfile.profileName,
        profileVersion: importedProfile.version
      }));
      
      if (updates.length > 0) {
        handleProfileAssignment(updates);
      }
      
      setImportedProfile(null);
    }
  }, [
    importedProfile, 
    productData, 
    handleProfileAssignment, 
    setImportedProfile, 
    selectedItems
  ]);
  
  return {
    openProfileSelectionModal: openSelectProfileModal
  };
}; 